export const drawGeometryType = Object.freeze({
    point: {name: 'draw_point'},
    polyline: {name: 'draw_line_string'},
    polygon: {name: 'draw_polygon'}
});